// Integer fractions align the form preview with server Decimal arithmetic.
function fraction(value) {
  const match = String(value || 0).match(/^([+-]?)(\d*)(?:\.(\d*))?(?:e([+-]?\d+))?$/i);
  if (!match || !Number.isFinite(Number(value || 0))) return [0n, 1n];
  const power = (match[3] || "").length - Number(match[4] || 0);
  const numerator = BigInt((match[2] || "0") + (match[3] || "")) * (match[1] === "-" ? -1n : 1n);
  return power >= 0 ? [numerator, 10n ** BigInt(power)] : [numerator * 10n ** BigInt(-power), 1n];
}
function halfUp(numerator, denominator) {
  const sign = numerator < 0n ? -1n : 1n;
  return sign * ((numerator * sign + denominator / 2n) / denominator);
}
export function billTotals(lines, items, interstate) {
  let taxable = 0n, cgst = 0n, sgst = 0n, igst = 0n;
  for (const line of lines) {
    if (!line.item_id) continue;
    const master = items.find((item) => item.id === line.item_id);
    const [q, qd] = fraction(line.qty), [r, rd] = fraction(line.rate);
    const [discount, dd] = fraction(line.discount_pct), [g, gd] = fraction(master?.gst_rate);
    const cents = halfUp(q * r * (100n * dd - discount), qd * rd * dd);
    taxable += cents;
    if (interstate) igst += halfUp(cents * g, gd * 100n);
    else { const component = halfUp(cents * g, gd * 200n); cgst += component; sgst += component; }
  }
  const total = taxable + cgst + sgst + igst, grand = halfUp(total, 100n);
  return { taxable: Number(taxable) / 100, cgst: Number(cgst) / 100, sgst: Number(sgst) / 100,
    igst: Number(igst) / 100, grand: Number(grand), roundOff: Number(grand * 100n - total) / 100 };
}
